import { ActionWhatsAppStyle } from './styles'
import { WhatsApp } from '@mui/icons-material'
import { settings } from 'main/settings'

const ActionWhatsApp = () => {
  function openWhats() {
    const url = settings.WHATSAPP_URL
    window.open(url, '_blank')
  }

  return (
    <ActionWhatsAppStyle onClick={openWhats}>
      <WhatsApp style={{ color: '#fff', fontSize: 30 }} />
    </ActionWhatsAppStyle>
  )
}

export default ActionWhatsApp
